import React, { useEffect } from 'react'
import Sdata from '../../Sdata'
import Card from '../../component/Card'
import Common from '../../component/Common'
import headimg from '../../images/image.png'
import vector from '../../images/Vector.png'
const Professional_Courses = () => {
    useEffect(() => {
        document.title = "CareerGrads | Job Ready"
    }, [])
    return (
        <>
            <Common name='Explore Our Courses! '
                imgsrc={headimg}
                visit='0'
                btname='0'
                content='We Provide Courses that are curated from our own Experts'
                side={"order-lg-last"}
            />
            <div className="my-5">
                <div className="text-center mb-3">
                    <h1><strong>Courses</strong></h1>
                </div>
                <img src={vector} className="vector1" />
                <div className="container mb-5">
                    <div className="mt-3">
                        <div className="row">
                            <div className="col-sm-12 col-xs-12 col-md-12 mx-auto ">

                                <div className="row gy-3">
                                    {Sdata.map((data, ind) => {
                                        return (<Card key={ind} imgsrc={data.img} title={data.title} text={data.text} />);
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    window.scrollTo(0, 0)
                }
            </div>

        </>
    )
}

export default Professional_Courses
